export default {"src":"/_next/static/media/cancel-alt.423ff4e1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};